import { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router'
import { jwtDecode } from 'jwt-decode'
import { NotificationManager } from 'react-notifications'
import { isMobile, isAndroid, isIOS, osVersion } from 'react-device-detect'

// import useForm from './hooks/useForm'
import config from './config'
import usePrev from './hooks/usePrev'
import { loadUser, logout } from './actions/authActions'
import { getAdminsetting } from './actions/adminsettingActions'

export const noAuthAllowedPaths = new RegExp(
  /(\/register\/(homeowner|builder|realtor|professional|login|logout|success)|\/login|\/logout)/,
)
const allAllowedPaths = new RegExp(
  /(\/(#register)*$|\/search|verify-email\/+|hometeam-status\/+|reset-password\/+|forgot-password|homeowner-report|general-sponsorship|address-search|unsubscribe|register-homeinformation|homeowner\/maintenance|homeowner\/team|get-review|homeowner-invitation|search-home-professionals|homepros-profile)/,
)

const { user_types } = config

let logoutMsg = false

// const initialState = {
//   logoutMsg: false,
// }

const Authorize = (props) => {
  const reduxDispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const error = useSelector((state) => state.error)
  const { data: adminsetting, loading: loadingAdminsetting } = useSelector((state) => state.adminsetting)
  const { token, isAuthenticated, user, isLoading } = useSelector((state) => state.auth)
  // const { state, dispatch } = useForm(initialState)
  // const { logoutMsg } = state;

  const prevError = usePrev(error)
  const prevIsAuthenticated = usePrev(isAuthenticated)
  const prevIsLoading = usePrev(isLoading)

  useEffect(() => {
    const mobilePlatform = window.localStorage.getItem('mobilePlatform')
    if (isAndroid || isIOS || mobilePlatform != null) {
      if (isAndroid || mobilePlatform === 'android') {
        window.newTabScheme = window.androidURLScheme
      } else if (isIOS || mobilePlatform === 'ios') {
        // window.newTabScheme = window.iosURLSchemeNew // iOS 15, 17, 18 & newer
        if ((osVersion === 16 && osVersion !== 15) || osVersion < 15) {
          window.newTabScheme = window.iosURLSchemeOld // iOS 16 & older
        }
      }
    }
  }, [isMobile, isAndroid, isIOS, osVersion])

  useEffect(() => {
    updateExternalLinks()
  }, [updateExternalLinks])

  useEffect(() => {
    updateExternalLinks()
  }, [location.pathname, updateExternalLinks])

  const updateExternalLinks = useCallback(() => {
    const mobilePlatform = window.localStorage.getItem('mobilePlatform')
    const externalLinks = document.querySelectorAll('a[target="_blank"][href^="https:"]')
    // console.log('device detecting...')
    if (externalLinks.length > 0) {
      // console.log('links to replace: ' + externalLinks.length)
      externalLinks.forEach((elem) => {
        let newHref = elem.getAttribute('href')
        // console.log('current href: ' + newHref)
        if (isAndroid || mobilePlatform === 'android') {
          // newHref = newHref.replace(/https/, 'googlechrome')
          // newHref = `intent:${newHref}#Intent;scheme=https;package=com.android.chrome;end`
          newHref = window.androidURLScheme.replace(/URL/, newHref)
        } else if (isIOS || mobilePlatform === 'ios') {
          const newScheme = osVersion === 16 || osVersion < 15 ? window.iosURLSchemeOld : window.iosURLSchemeNew
          newHref = newHref.replace(/https/, newScheme.replace(/URL/, ''))
        } else {
          // newHref = ''
        }
        if (newHref !== '') {
          // console.log('href replacing: ' + newHref)
          elem.setAttribute('href', newHref)
        }
      })
    }
  }, [isMobile, isAndroid, isIOS, osVersion])

  useEffect(() => {
    if (adminsetting == null && !loadingAdminsetting) {
      reduxDispatch(
        getAdminsetting('', ({ client }) => {
          window.localStorage.setItem('client-version', client)
        }),
      )
    }
  }, [reduxDispatch, adminsetting, loadingAdminsetting])

  useEffect(() => {
    if (error !== prevError) {
      if (error && error.id === 'AUTH_ERROR') {
        logoutFunc()
      }
    }
  }, [reduxDispatch, error, logoutFunc])

  useEffect(() => {
    const pathname = window.location
      ? window.location.pathname
      : typeof location != 'undefined'
        ? location.pathname
        : null
    const noAuthPath = pathname ? pathname.match(noAuthAllowedPaths) : null
    const authPath = pathname ? pathname.match(allAllowedPaths) : null
    const authLocationMatch = noAuthPath === null
    const noAuthLocationMatch = noAuthPath !== null
    const allAllowedPathsMatch = authPath !== null

    let tokenDecoded = null
    try {
      if (typeof token != 'undefined' && token) {
        tokenDecoded = jwtDecode(token)
      }
    } catch (e) {}

    if (token) {
      if ((!tokenDecoded && noAuthPath !== null) || (tokenDecoded && tokenDecoded.exp < Date.now() / 1000)) {
        logoutFunc(allAllowedPathsMatch)
      }
    }
    if (!user && !isLoading && !prevIsLoading) {
      reduxDispatch(loadUser())
    }
    // if (logoutMsg !== prevState.logoutMsg) this.setState({ logoutMsg })

    let { to = '/login', toSuccess = '/' } = props
    setTimeout(() => {
      if (pathname.match(/log(out|in)/)) {
        // reduxDispatch(logout())
        // if (location && typeof location != 'undefined') navigate('/login')
        // else window.location.href = '/login'
        return
      }
      if (user && window.localStorage.getItem('user_id') && user._id !== window.localStorage.getItem('user_id')) {
        // window.location.href = '/logout'
      } else if (!isAuthenticated || isAuthenticated !== prevIsAuthenticated) {
        if (!isAuthenticated || token == null) {
          if (to === '/') to = '/login'
        } else if (user && (isAuthenticated || token !== null)) {
          if (pathname.match('register') || user.login_count <= 1) {
            if (tokenDecoded.user_type[0] === 'homeowner') {
              // toSuccess = '/homeowner-onboarding'
              // toSuccess = '/register-homeinformation'
              toSuccess = '/homeowner/home'
            } else toSuccess = '/register-professional'
          } else if (!location || location?.state?.fromLogin) {
            // toSuccess = '/' + tokenDecoded.user_type[0].replace(/_/g, '-') + '/home'
            const currProfileType = window.localStorage.getItem('profileType')
            if (currProfileType && user.user_type_text.includes(currProfileType)) {
              let userType = ''
              switch (currProfileType) {
                case user_types.homeowner:
                  userType = 'homeowner'
                  break
                default:
                  userType = 'professional'
              }
              toSuccess = '/' + userType + '/home'
              window.setCookie('userType', userType)
            } else if (user.user_type.length > 1) {
              toSuccess = '/select-profile'
            } else {
              let userType = ''
              switch (user.user_type[0]) {
                case user_types.homeowner:
                  userType = 'homeowner'
                  break
                default:
                  userType = 'professional'
              }
              toSuccess = '/' + userType + '/home'
              window.setCookie('userType', userType)
              window.localStorage.setItem('profileType', user.user_type_text[0])
            }
          }
        }

        if (
          toSuccess.search(/homeowner/) === 1 &&
          user &&
          user?.phone?.replace(/[\s]/g, '') === '' &&
          pathname &&
          pathname.match('enterphone') === null &&
          pathname.match('select-profile') === null &&
          window.getCookie('skipEnterPhone') !== 'true'
        ) {
          toSuccess = '/homeowner-enterphone'
          setTimeout(() => {
            if (location) navigate(toSuccess)
            else window.location.href = toSuccess
          }, 1000)
        }

        // console.log({ to, toSuccess })
        // console.log('hasAuth: ' + isAuthenticated, ', auth-location: ' + authLocationMatch, ', no-auth-location: ' + noAuthLocationMatch, ', allAllowedPaths: ' + allAllowedPathsMatch)

        if (isAuthenticated === false && authLocationMatch && !allAllowedPathsMatch) {
          try {
            navigate(to)
          } catch (e) {
            // window.location.href = to;
          }
        } else if (isAuthenticated === true && noAuthLocationMatch && !allAllowedPathsMatch) {
          try {
            navigate(toSuccess)
          } catch (e) {
            // window.location.href = toSuccess;
          }
        }
      }
      if (user && user?._id) {
        window.clarity('identify', user.email, token, null, user?.name || user.email)
      }
    }, 500)
  }, [reduxDispatch, logoutFunc, props, navigate, user, isAuthenticated, token, isLoading])

  const logoutFunc = useCallback(
    (allAllowedPathsMatch) => {
      if (!logoutMsg && !allAllowedPathsMatch) {
        const pathname = window.location
          ? window.location.pathname
          : typeof location != 'undefined'
            ? location.pathname
            : null
        logoutMsg = true
        NotificationManager.info(
          'Your session has expired, click to login again',
          'Session Expired',
          5000,
          () => {
            navigate('/login')
          },
          true,
        )
        window.localStorage.setItem('session-exp-message', true)
        if (token) {
          window.localStorage.setItem('token', null)
          reduxDispatch(logout())
        }
        if (pathname.search('/register/') === -1) {
          window.localStorage.setItem('login-redirect-page', pathname)
          if (location) {
            navigate('/login')
          } else {
            window.location.href = '/login'
          }
        }
      }
    },
    [reduxDispatch, navigate, location, logoutMsg, token],
  )

  return props.children
}

export default Authorize
